import { useTranslation } from "react-i18next";

import {
  IconMenuAgencias,
  IconMenuClientes,
  IconMenuContatos,
  IconMenuDashBoard,
  IconMenuDesks,
  IconMenuOverView,
  IconMenuPipe,
  IconMenuProdutos,
  IconMenuRepresentados,
  IconMenuRepresentates,
} from "./IconsMenu";
import {
  Briefcase,
  Users,
  Network,
  Building,
  Megaphone,
  Link2,
  BookmarkCheck,
  Truck,
  FileText,
  UserSearch,
  Activity,
  Trophy,
  CalendarCheck,
  MessageSquareWarning,
  CreditCard,
  Radio,
  Ticket,
  Workflow,
} from "lucide-react";
import { IconController } from "@/assets/images/Icons";
import { useLayout } from "@/contexts/UseLayout";
import { MenuItemAnimated } from "./MenuItemAnimated";
import TemPermissao from "@/components/utils/NiveisDeAcesso";

export function UserGoOn({
  isExpanded,
}: {
  isExpanded: boolean;
  is_admin?: unknown;
}) {
  const { t } = useTranslation();
  const { userLogged } = useLayout();

  const mockData = [
    {
      id: 1,
      name: t("sidebar:overview"),
      icon: <IconMenuOverView />,
      to: "/overview",
      visible: TemPermissao(userLogged, "overview", "visualizar"),
    },
    {
      id: 1.05,
      name: "Jornadas",
      icon: <Workflow size={22} />,
      to: "/overview/jornadas",
      visible: TemPermissao(userLogged, "jornadas", "visualizar"),
    },
    {
      id: 1.1,
      name: t("sidebar:organizations"),
      icon: <Network size={22} />,
      to: "/organizacoes",
      visible: TemPermissao(userLogged, "organizacoes", "visualizar"),
    },
    {
      id: 1.2,
      name: t("sidebar:users"),
      icon: <Users size={22} />,
      to: "/usuarios",
      visible: TemPermissao(userLogged, "usuarios", "visualizar"),
    },
    {
      id: 1.3,
      name: t("sidebar:advertising_campaigns"),
      icon: <Megaphone size={22} />,
      to: "/painel-campanhas",
      visible: TemPermissao(
        userLogged,
        "campanhas-publicitarias",
        "visualizar",
      ),
    },

    {
      id: 2,
      name: t("sidebar:dashboard"),
      icon: <IconMenuDashBoard />,
      to: "/dashboard",
      visible: TemPermissao(userLogged, "dashboard", "visualizar"),
    },
    {
      id: 3,
      name: t("sidebar:desks"),
      icon: <IconMenuDesks />,
      to: "/desks",
      visible: TemPermissao(userLogged, "desks", "visualizar"),
    },
    {
      id: 3.5,
      name: t("sidebar:taskScore"),
      icon: <Trophy size={20} />,
      to: "/task-score",
      visible: TemPermissao(userLogged, "task-score", "visualizar"),
    },
    {
      id: 4,
      name: t("sidebar:jobs"),
      icon: <Briefcase size={20} />,
      to: "/jobs",
      visible: TemPermissao(userLogged, "jobs", "visualizar"),
    },
    {
      id: 5,
      name: t("sidebar:campaigns"),
      icon: <Megaphone size={20} />,
      to: "/campanhas",
      visible: TemPermissao(userLogged, "campanhas", "visualizar"),
    },
    {
      id: 5.5,
      name: "Cronograma Social",
      icon: <CalendarCheck size={22} />,
      to: "/cronograma",
      visible: TemPermissao(userLogged, "cronograma-social", "visualizar"),
    },
    {
      id: 6,
      name: t("sidebar:prospecting"),
      icon: <Users size={20} />,
      to: "/prospeccoes",
      visible: TemPermissao(userLogged, "prospeccoes", "visualizar"),
    },
    {
      id: 7,
      name: t("sidebar:contacts"),
      icon: <IconMenuContatos />,
      to: "/contatos",
      visible:
        TemPermissao(userLogged, "contatos", "visualizar") &&
        userLogged?.data?.id !== 5910,
    },
    {
      id: 8,
      name: t("sidebar:controller"),
      icon: <IconController />,
      to: "/controller",
      visible: TemPermissao(userLogged, "controller", "visualizar"),
    },
    {
      id: 8.5,
      name: t("sidebar:ad_desk_pay"),
      icon: <CreditCard size={20} />,
      to: "/ad-desk-pay-financeiro",
      visible: TemPermissao(userLogged, "ad-desk-pay", "visualizar"),
    },
    {
      id: 8.6,
      name: "Ad Desk Rádio",
      icon: <Radio size={20} />,
      to: "/ad-desk-radio",
      visible: TemPermissao(userLogged, "ad-desk-radio", "visualizar"),
    },
    {
      id: 8.7,
      name: t("sidebar:password_panel"),
      icon: <Ticket size={20} />,
      to: "/painel-senhas",
      visible: TemPermissao(userLogged, "painel-senhas", "visualizar"),
    },
    {
      id: 9,
      name: t("sidebar:clients"),
      icon: <IconMenuClientes />,
      to: "/clientes",
      visible: TemPermissao(userLogged, "clientes", "visualizar"),
    },
    {
      id: 10,
      name: t("sidebar:agencies"),
      icon: <IconMenuAgencias />,
      to: "/agencias",
      visible: TemPermissao(userLogged, "agencias", "visualizar"),
    },
    {
      id: 11,
      name: t("sidebar:companies"),
      icon: <Building />,
      to: "/empresas",
      visible: TemPermissao(userLogged, "empresas", "visualizar"),
    },
    {
      id: 21,
      name: "Fornecedores",
      icon: <Truck size={20} />,
      to: "/empresas-fornecedores",
      visible: TemPermissao(userLogged, "fornecedores-empresas", "visualizar"),
    },
    {
      id: 12,
      name: t("sidebar:representatives"),
      icon: <IconMenuRepresentates />,
      to: "/representantes",
      visible: TemPermissao(userLogged, "representantes", "visualizar"),
    },
    {
      id: 13,
      name: t("sidebar:represented"),
      icon: <IconMenuRepresentados />,
      to: "/representados",
      visible: TemPermissao(userLogged, "representados", "visualizar"),
    },
    {
      id: 14,
      name: t("sidebar:products"),
      icon: <IconMenuProdutos />,
      to: "/produtos",
      visible: TemPermissao(userLogged, "produtos", "visualizar"),
    },
    {
      id: 15,
      name: t("sidebar:pipe"),
      icon: <IconMenuPipe />,
      to: "/relatorios",
      visible: TemPermissao(userLogged, "pipe", "visualizar"),
    },
    {
      id: 16,
      name: t("sidebar:goals"),
      icon: (
        <div className="flex-shrink-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM3 3H2v1h1z"
            />
            <path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z" />
            <path
              fillRule="evenodd"
              d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5zM2 7h1v1H2zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm1 .5H2v1h1z"
            />
          </svg>
        </div>
      ),
      to: "/metas",
      visible: TemPermissao(userLogged, "metas", "visualizar"),
    },
    {
      id: 18,
      name: t("sidebar:formats"),
      icon: <IconMenuProdutos />,
      to: "/formatos",
      visible: TemPermissao(userLogged, "formatos", "visualizar"),
    },
    {
      id: 19,
      name: t("sidebar:sales_area"),
      icon: (
        <div className="flex-shrink-0">
          <svg
            width="17"
            height="23"
            viewBox="0 0 17 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.486 2.87568C14.6305 2.87447 13.7744 2.87267 12.9189 2.87868C12.7882 2.87988 12.7343 2.85526 12.7462 2.70938C12.7604 2.53828 12.7515 2.36538 12.7491 2.19308C12.7432 1.73741 12.4486 1.44144 11.9948 1.43844C11.5522 1.43544 11.1097 1.43304 10.6672 1.44084C10.5476 1.44264 10.4914 1.40962 10.4411 1.29315C10.2015 0.740832 9.79864 0.353006 9.24073 0.13808C9.09992 0.084049 8.95378 0.0456266 8.81002 0H8.18998C8.18111 0.0108063 8.17401 0.0300175 8.16395 0.0318185C7.39246 0.170499 6.85467 0.609955 6.54228 1.33458C6.50028 1.43183 6.44052 1.43964 6.35474 1.43904C5.9045 1.43664 5.45486 1.43544 5.00463 1.43904C4.5473 1.44204 4.25621 1.73381 4.2503 2.19248C4.24793 2.35697 4.23787 2.52327 4.25325 2.68597C4.26864 2.84746 4.21243 2.88108 4.05979 2.87928C3.21139 2.87147 2.36298 2.87447 1.51517 2.87568C0.580393 2.87688 0 3.46582 0 4.41737C0 10.0985 0 15.7796 0 21.4613C0 22.4111 0.580984 23.0006 1.51695 23.0006C6.17133 23.0012 10.8263 23.0012 15.4807 23.0006C16.4184 23.0006 16.9988 22.4123 16.9988 21.4625C16.9994 15.7814 16.9988 10.1003 16.9988 4.41857C16.9988 3.46462 16.4214 2.87688 15.4854 2.87568H15.486ZM5.66371 3.03297C5.66075 2.90509 5.69802 2.87027 5.82227 2.87267C6.22044 2.88048 6.6192 2.87688 7.01737 2.87508C7.48298 2.87267 7.76046 2.60852 7.79181 2.13965C7.81962 1.73021 8.12372 1.43304 8.51065 1.43904C8.88634 1.44444 9.18038 1.74041 9.20759 2.13965C9.23954 2.60792 9.51702 2.87327 9.98204 2.87568C10.3802 2.87748 10.779 2.88108 11.1771 2.87327C11.3014 2.87087 11.3387 2.90509 11.3357 3.03297C11.3274 3.39978 11.3256 3.76659 11.3357 4.13341C11.3398 4.28049 11.2996 4.31832 11.1547 4.31712C10.2696 4.30991 9.3839 4.31351 8.49882 4.31351C7.61373 4.31351 6.72806 4.30991 5.84297 4.31712C5.69862 4.31832 5.65779 4.28049 5.66193 4.13341C5.67258 3.76719 5.67081 3.39978 5.66193 3.03297H5.66371ZM15.3351 21.567C10.7766 21.5616 6.21748 21.561 1.65894 21.5682C1.45542 21.5682 1.41164 21.5141 1.41223 21.3142C1.41874 18.522 1.41696 15.7304 1.41696 12.9381C1.41696 10.1459 1.41874 7.33928 1.41223 4.53985C1.41223 4.35614 1.4495 4.30511 1.63646 4.30811C2.44759 4.32012 3.25931 4.31652 4.07044 4.30991C4.21184 4.30871 4.26449 4.34113 4.25266 4.49182C4.23905 4.67012 4.24615 4.85083 4.2503 5.03033C4.26035 5.43497 4.5538 5.74715 4.9502 5.74835C7.31792 5.75255 9.68623 5.75255 12.0539 5.74835C12.4403 5.74775 12.7337 5.43917 12.7473 5.04774C12.7538 4.85323 12.7544 4.65811 12.7473 4.4642C12.7432 4.35314 12.7669 4.30991 12.8899 4.31111C13.7383 4.31712 14.5867 4.31592 15.4345 4.31231C15.5434 4.31231 15.6037 4.33212 15.583 4.457C15.5771 4.49362 15.5819 4.53144 15.5819 4.56926C15.5819 10.1531 15.5807 15.7376 15.5872 21.3214C15.5872 21.5339 15.5251 21.5688 15.334 21.5688L15.3351 21.567Z"
              fill="currentColor"
            />
          </svg>
        </div>
      ),
      to: "/vendas",
      visible: TemPermissao(userLogged, "area-de-vendas", "visualizar"),
    },
    {
      id: 20,
      name: t("sidebar:ad_link_users"),
      icon: <Link2 size={20} />,
      to: "/ad-link/usuarios",
      visible: [135, 149].includes(userLogged?.data?.id),
    },
    {
      id: 22,
      name: "Notas Fiscais",
      icon: <FileText size={20} />,
      to: "/notas-fiscais",
      visible: TemPermissao(userLogged, "notas-fiscais", "visualizar"),
    },
    {
      id: 23,
      name: "Recrutamento",
      icon: <UserSearch size={20} />,
      to: "/dash-recrutamento",
      visible:
        TemPermissao(userLogged, "vagas", "visualizar") ||
        TemPermissao(userLogged, "candidaturas", "visualizar"),
    },
    {
      id: 27,
      name: "Meus salvos",
      icon: <BookmarkCheck size={20} />,
      to: "/meus-salvos",
      visible: !!userLogged?.data?.id,
    },
    {
      id: 24,
      name: "Saúde do Sistema",
      icon: <Activity size={20} />,
      to: "/admin/saude",
      visible: !!userLogged?.data?.is_admin,
    },
    {
      id: 25,
      name: "Carteirização",
      icon: <Briefcase size={20} />,
      to: "/carteirizacao",
      visible: TemPermissao(userLogged, "carteiras", "visualizar"),
    },
    {
      id: 26,
      name: "Feedback",
      icon: <MessageSquareWarning size={20} />,
      to: "/feedback",
      visible: !!userLogged?.data?.id,
    },
  ];

  return (
    <>
      {mockData.map((item) => (
        <MenuItemAnimated
          key={item?.id}
          to={item?.to}
          icon={item?.icon}
          label={item?.name}
          isExpanded={isExpanded}
          visible={item?.visible}
        />
      ))}
    </>
  );
}
